import { TimeFilterType } from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';

export const dailyData = {
  data: [
    {
      name: '2026-05-18',
      aggValue: 107,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '7',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '5',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '95',
        },
      ],
    },
    {
      name: '2026-05-19',
      aggValue: 67,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '14',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '2',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '51',
        },
      ],
    },
    {
      name: '2026-05-20',
      aggValue: 49,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '7',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '1',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '41',
        },
      ],
    },
    {
      name: '2026-05-21',
      aggValue: 39,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '4',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '1',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '34',
        },
      ],
    },
    {
      name: '2026-05-22',
      aggValue: 61,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '5',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '56',
        },
      ],
    },
    {
      name: '2026-05-23',
      aggValue: 29,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '2',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '27',
        },
      ],
    },
    {
      name: '2026-05-24',
      aggValue: 21,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '2',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '19',
        },
      ],
    },
    {
      name: '2026-05-25',
      aggValue: 21,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '2',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '19',
        },
      ],
    },
    {
      name: '2026-05-26',
      aggValue: 60,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '9',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '51',
        },
      ],
    },
    {
      name: '2026-05-27',
      aggValue: 90,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '49',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '1',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '40',
        },
      ],
    },
    {
      name: '2026-05-28',
      aggValue: 84,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '44',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '1',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '39',
        },
      ],
    },
    {
      name: '2026-05-29',
      aggValue: 87,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '29',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '2',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '56',
        },
      ],
    },
    {
      name: '2026-05-30',
      aggValue: 36,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '36',
        },
      ],
    },
    {
      name: '2026-05-31',
      aggValue: 33,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '33',
        },
      ],
    },
    {
      name: '2026-06-01',
      aggValue: 105,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '27',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '1',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '77',
        },
      ],
    },
    {
      name: '2026-06-02',
      aggValue: 108,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '34',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '1',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '73',
        },
      ],
    },
    {
      name: '2026-06-03',
      aggValue: 96,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '19',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '77',
        },
      ],
    },
    {
      name: '2026-06-04',
      aggValue: 101,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '34',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '67',
        },
      ],
    },
    {
      name: '2026-06-05',
      aggValue: 234,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '159',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '2',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '73',
        },
      ],
    },
    {
      name: '2026-06-06',
      aggValue: 42,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '5',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '37',
        },
      ],
    },
    {
      name: '2026-06-07',
      aggValue: 35,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '2',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '33',
        },
      ],
    },
    {
      name: '2026-06-08',
      aggValue: 124,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '23',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '5',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '96',
        },
      ],
    },
    {
      name: '2026-06-09',
      aggValue: 105,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '22',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '5',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '78',
        },
      ],
    },
    {
      name: '2026-06-10',
      aggValue: 104,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '22',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '2',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '80',
        },
      ],
    },
    {
      name: '2026-06-11',
      aggValue: 84,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '22',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '3',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '59',
        },
      ],
    },
    {
      name: '2026-06-12',
      aggValue: 126,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '71',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '8',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '47',
        },
      ],
    },
    {
      name: '2026-06-13',
      aggValue: 36,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '10',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '26',
        },
      ],
    },
    {
      name: '2026-06-14',
      aggValue: 49,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '5',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '44',
        },
      ],
    },
    {
      name: '2026-06-15',
      aggValue: 89,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '26',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '1',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '62',
        },
      ],
    },
    {
      name: '2026-06-16',
      aggValue: 52,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '7',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '3',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '42',
        },
      ],
    },
  ],
  aggregates: {
    staffAnswered: 0,
    staffUnanswered: 0,
    followupTasksScheduling: 0,
    followupTasksOthers: 0,
    perIncreaseStaffAnswered: 0,
    perIncreaseStaffUnanswered: 0,
    perIncreaseTotalStaffTransfers: 0,
    staffTransfers: 0,
    totalAiThreads: 0,
  },
  summary: [
    {
      name: '2026-05-18',
      count: 1,
      total: 107,
      average: 107,
    },
    {
      name: '2026-05-19',
      count: 1,
      total: 67,
      average: 67,
    },
    {
      name: '2026-05-20',
      count: 1,
      total: 49,
      average: 49,
    },
    {
      name: '2026-05-21',
      count: 1,
      total: 39,
      average: 39,
    },
    {
      name: '2026-05-22',
      count: 1,
      total: 61,
      average: 61,
    },
    {
      name: '2026-05-23',
      count: 1,
      total: 29,
      average: 29,
    },
    {
      name: '2026-05-24',
      count: 1,
      total: 21,
      average: 21,
    },
    {
      name: '2026-05-25',
      count: 1,
      total: 21,
      average: 21,
    },
    {
      name: '2026-05-26',
      count: 1,
      total: 60,
      average: 60,
    },
    {
      name: '2026-05-27',
      count: 1,
      total: 90,
      average: 90,
    },
    {
      name: '2026-05-28',
      count: 1,
      total: 84,
      average: 84,
    },
    {
      name: '2026-05-29',
      count: 1,
      total: 87,
      average: 87,
    },
    {
      name: '2026-05-30',
      count: 1,
      total: 36,
      average: 36,
    },
    {
      name: '2026-05-31',
      count: 1,
      total: 33,
      average: 33,
    },
    {
      name: '2026-06-01',
      count: 1,
      total: 105,
      average: 105,
    },
    {
      name: '2026-06-02',
      count: 1,
      total: 108,
      average: 108,
    },
    {
      name: '2026-06-03',
      count: 1,
      total: 96,
      average: 96,
    },
    {
      name: '2026-06-04',
      count: 1,
      total: 101,
      average: 101,
    },
    {
      name: '2026-06-05',
      count: 1,
      total: 234,
      average: 234,
    },
    {
      name: '2026-06-06',
      count: 1,
      total: 42,
      average: 42,
    },
    {
      name: '2026-06-07',
      count: 1,
      total: 35,
      average: 35,
    },
    {
      name: '2026-06-08',
      count: 1,
      total: 124,
      average: 124,
    },
    {
      name: '2026-06-09',
      count: 1,
      total: 105,
      average: 105,
    },
    {
      name: '2026-06-10',
      count: 1,
      total: 104,
      average: 104,
    },
    {
      name: '2026-06-11',
      count: 1,
      total: 84,
      average: 84,
    },
    {
      name: '2026-06-12',
      count: 1,
      total: 126,
      average: 126,
    },
    {
      name: '2026-06-13',
      count: 1,
      total: 36,
      average: 36,
    },
    {
      name: '2026-06-14',
      count: 1,
      total: 49,
      average: 49,
    },
    {
      name: '2026-06-15',
      count: 1,
      total: 89,
      average: 89,
    },
    {
      name: '2026-06-16',
      count: 1,
      total: 52,
      average: 52,
    },
  ],
};

export const dayOfWeekData = {
  data: [
    {
      name: 'Monday',
      aggValue: 339,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '9',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '254',
        },
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '76',
        },
      ],
    },
    {
      name: 'Tuesday',
      aggValue: 413,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '105',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '11',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '297',
        },
      ],
    },
    {
      name: 'Wednesday',
      aggValue: 393,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '108',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '7',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '278',
        },
      ],
    },
    {
      name: 'Thursday',
      aggValue: 308,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '104',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '5',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '199',
        },
      ],
    },
    {
      name: 'Friday',
      aggValue: 508,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '264',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '232',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '12',
        },
      ],
    },
    {
      name: 'Saturday',
      aggValue: 143,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '17',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '126',
        },
      ],
    },
    {
      name: 'Sunday',
      aggValue: 138,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '7',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '129',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '2',
        },
      ],
    },
  ],
  aggregates: {
    staffAnswered: 0,
    staffUnanswered: 0,
    followupTasksScheduling: 0,
    followupTasksOthers: 0,
    perIncreaseStaffAnswered: 0,
    perIncreaseStaffUnanswered: 0,
    perIncreaseTotalStaffTransfers: 0,
    staffTransfers: 0,
    totalAiThreads: 0,
  },
  summary: [
    {
      name: 'Monday',
      count: 4,
      total: 339,
      average: 84,
    },
    {
      name: 'Tuesday',
      count: 5,
      total: 413,
      average: 82,
    },
    {
      name: 'Wednesday',
      count: 5,
      total: 393,
      average: 78,
    },
    {
      name: 'Thursday',
      count: 4,
      total: 308,
      average: 77,
    },
    {
      name: 'Friday',
      count: 4,
      total: 508,
      average: 127,
    },
    {
      name: 'Saturday',
      count: 4,
      total: 143,
      average: 35,
    },
    {
      name: 'Sunday',
      count: 4,
      total: 138,
      average: 34,
    },
  ],
};

export const hourlyData = {
  data: [
    {
      name: '0',
      aggValue: 1,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '1',
        },
      ],
    },
    {
      name: '1',
      aggValue: 2,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '2',
        },
      ],
    },
    {
      name: '2',
      aggValue: 0,
      values: [],
    },
    {
      name: '3',
      aggValue: 0,
      values: [],
    },
    {
      name: '4',
      aggValue: 2,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '2',
        },
      ],
    },
    {
      name: '5',
      aggValue: 1,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '1',
        },
      ],
    },
    {
      name: '6',
      aggValue: 7,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '7',
        },
      ],
    },
    {
      name: '7',
      aggValue: 21,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '20',
        },
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '1',
        },
      ],
    },
    {
      name: '8',
      aggValue: 122,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '104',
        },
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '15',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '3',
        },
      ],
    },
    {
      name: '9',
      aggValue: 205,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '177',
        },
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '22',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '6',
        },
      ],
    },
    {
      name: '10',
      aggValue: 236,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '10',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '181',
        },
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '45',
        },
      ],
    },
    {
      name: '11',
      aggValue: 213,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '60',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '148',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '5',
        },
      ],
    },
    {
      name: '12',
      aggValue: 236,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '92',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '141',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '3',
        },
      ],
    },
    {
      name: '13',
      aggValue: 221,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '61',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '4',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '156',
        },
      ],
    },
    {
      name: '14',
      aggValue: 146,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '3',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '123',
        },
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '20',
        },
      ],
    },
    {
      name: '15',
      aggValue: 165,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '35',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '123',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '7',
        },
      ],
    },
    {
      name: '16',
      aggValue: 162,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '51',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '110',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '1',
        },
      ],
    },
    {
      name: '17',
      aggValue: 170,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '113',
        },
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '55',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '2',
        },
      ],
    },
    {
      name: '18',
      aggValue: 132,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '79',
        },
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '51',
        },
        {
          key: 'SESSION_INITIATED_FOR_INCOMING_VOICE_CALL',
          value: '2',
        },
      ],
    },
    {
      name: '19',
      aggValue: 195,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '34',
        },
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '161',
        },
      ],
    },
    {
      name: '20',
      aggValue: 15,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '14',
        },
        {
          key: 'SESSION_INITIATED_FOR_DIRECT_MESSAGE',
          value: '1',
        },
      ],
    },
    {
      name: '21',
      aggValue: 6,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '6',
        },
      ],
    },
    {
      name: '22',
      aggValue: 1,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '1',
        },
      ],
    },
    {
      name: '23',
      aggValue: 2,
      values: [
        {
          key: 'SESSION_INITIATED_FOR_MISSED_CALL',
          value: '2',
        },
      ],
    },
  ],
  aggregates: {
    staffAnswered: 0,
    staffUnanswered: 0,
    followupTasksScheduling: 0,
    followupTasksOthers: 0,
    perIncreaseStaffAnswered: 0,
    perIncreaseStaffUnanswered: 0,
    perIncreaseTotalStaffTransfers: 0,
    staffTransfers: 0,
    totalAiThreads: 0,
  },
  summary: [
    {
      name: '0',
      count: 1,
      total: 1,
      average: 1,
    },
    {
      name: '1',
      count: 2,
      total: 2,
      average: 1,
    },
    {
      name: '2',
      count: 0,
      total: 0,
      average: 0,
    },
    {
      name: '3',
      count: 0,
      total: 0,
      average: 0,
    },
    {
      name: '4',
      count: 2,
      total: 2,
      average: 1,
    },
    {
      name: '5',
      count: 1,
      total: 1,
      average: 1,
    },
    {
      name: '6',
      count: 7,
      total: 7,
      average: 1,
    },
    {
      name: '7',
      count: 12,
      total: 21,
      average: 1,
    },
    {
      name: '8',
      count: 26,
      total: 122,
      average: 4,
    },
    {
      name: '9',
      count: 30,
      total: 205,
      average: 6,
    },
    {
      name: '10',
      count: 30,
      total: 236,
      average: 7,
    },
    {
      name: '11',
      count: 30,
      total: 213,
      average: 7,
    },
    {
      name: '12',
      count: 30,
      total: 236,
      average: 7,
    },
    {
      name: '13',
      count: 30,
      total: 221,
      average: 7,
    },
    {
      name: '14',
      count: 29,
      total: 146,
      average: 5,
    },
    {
      name: '15',
      count: 27,
      total: 165,
      average: 6,
    },
    {
      name: '16',
      count: 27,
      total: 162,
      average: 6,
    },
    {
      name: '17',
      count: 28,
      total: 170,
      average: 6,
    },
    {
      name: '18',
      count: 25,
      total: 132,
      average: 5,
    },
    {
      name: '19',
      count: 22,
      total: 195,
      average: 8,
    },
    {
      name: '20',
      count: 14,
      total: 15,
      average: 1,
    },
    {
      name: '21',
      count: 6,
      total: 6,
      average: 1,
    },
    {
      name: '22',
      count: 1,
      total: 1,
      average: 1,
    },
    {
      name: '23',
      count: 2,
      total: 2,
      average: 1,
    },
  ],
};

export const aiConversationsDummyDataNew = (payload?: any) => {
  if (payload?.filterType === TimeFilterType.DAY_OF_WEEK) {
    return dayOfWeekData;
  }
  if (payload?.filterType === TimeFilterType.HOURLY) {
    return hourlyData;
  }
  return dailyData;
};

import { generateGroupedDateLabels } from '../helpers';

const dateLabels = generateGroupedDateLabels();

const values = [50, 397, 429, 366, 438];

export const aiConversationsDummyData = {
  data: dateLabels.map((name, idx) => ({
    name,
    values: [{ key: 'totalAiThreads', value: String(values[idx]) }],
  })),
  aggregates: {
    staffAnswered: 0,
    staffUnanswered: 0,
    followupTasksScheduling: 0,
    followupTasksOthers: 0,
    perIncreaseStaffAnswered: 0,
    perIncreaseStaffUnanswered: 0,
    perIncreaseTotalStaffTransfers: 0,
    staffTransfers: 0,
    totalAiThreads: 1680,
  },
};
